import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import * as core from '../../core'

import type { Organization } from './organizations'

export type User = core.common.Identified<User.Id> & core.common.Named
export namespace User {
  export type Id = string

  export type Access = core.common.Identified<Access.Id> &
    core.common.Named &
    core.common.Coded & {
      userId: User.Id
      organization?: Organization.Lookup
    }

  export namespace Access {
    /** Grants a user access to the survey */
    export type Input = Pick<Access, 'userId'> & {
      /** Organizations a standard user works on, which admins are not given */
      organizationIds?: readonly Organization.Id[]
    }

    export type Id = core.dms.data.Record.Id
    export namespace Id {
      export const isId = core.dms.data.Record.Id.isId
      export const assertIsId: TypeAsserter<Id> =
        TypeAsserter.Factory.from(isId)
    }

    /**
     * Access a user is granted to a Space survey
     *
     * Survey admins administer the survey itself, while standard users work on
     * the organizations they are assigned to.
     */
    export enum Type {
      SurveyAdmin = 'Survey Admin',
      StandardUser = 'Standard User',
    }
    // Needs to be before namespace is defined
    const TYPES: ReadonlySet<Type> = new Set(Object.values(Type) as Type[])
    export namespace Type {
      export const ALL: readonly Type[] = Array.from(TYPES)
      export const isType = TypeChecker.Factory.oneOf(TYPES)
      export const assertIsType: TypeAsserter<Type> =
        TypeAsserter.Factory.from(isType)
    }
  }
}
